function Invite() {
  return (
    <div>
      <h1>Invite</h1>
    </div>
  );
}

export default Invite;
